import { t } from "i18next";
import React, { FC } from "react";

import { Card, Stack, Typography } from "@components/base";
import { useGetCurrentCompanyInfo } from "@api";
import { useUserStore } from "@store/user";

const CompanyInfo: FC = () => {
  const { user } = useUserStore();
  const { currentCompanyInfo, currentCompanyInfoEnabled } =
    useGetCurrentCompanyInfo(user);

  return currentCompanyInfoEnabled && currentCompanyInfo ? (
    <Card>
      <Stack spacing={2} p={2}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography variant="body2">{t("organizationSettings.vat")}</Typography>
          <Typography fontWeight={600}>{currentCompanyInfo.companyId}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography variant="body2">
            {t("organizationSettings.companyName")}
          </Typography>
          <Typography fontWeight={600}>{currentCompanyInfo.name}</Typography>
        </Stack>
      </Stack>
    </Card>
  ) : null;
};

export default CompanyInfo;
